import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { memo, useCallback, useContext, useState } from "react";
import { hasValue } from "@utils";
import { UXPContext } from "@core/context/Context";
import { HeaderNavigation } from "./HeaderNavigation";
import classNames from "classnames";
import UserProfile from "./components/UserProfile";
import ThemeChanger from "@theme/ThemeChanger";
import NotificationCenter from "@core/notification-center/NotificationCenter";
import { SkeletonLoader } from "@widget/loaders";
import Icon from "@icon/Icon";
import { useIsPHIconReady } from "@icon/phosphor/useIsPHIconReady";
import { useMessageBus } from "@realtime/messagebus/useMessageBus";
import { PermissionChangedBanner } from "./PermissionChangedBanner";
import { SafeLink } from "@core/route-context/RouteContext";
const HeaderBase = (props) => {
    const context = useContext(UXPContext);
    const [expiresAt, setExpiresAt] = useState(null);
    function handlePermissionChanged(payload) {
        var _a;
        if (context.isPublicSession)
            return;
        try {
            const parsed = JSON.parse(payload);
            console.log('payload_______', payload, parsed, context === null || context === void 0 ? void 0 : context.userDetails, context === null || context === void 0 ? void 0 : context.userKey);
            const affected = (parsed.userGroupKey && parsed.userGroupKey === ((_a = context.userDetails) === null || _a === void 0 ? void 0 : _a.UserGroupKey)) ||
                (parsed.userKey && parsed.userKey === context.userKey);
            if (affected)
                setExpiresAt(parsed.expiresAt);
        }
        catch (_b) { }
    }
    useMessageBus(context, 'iviva_usergroup_permissions_changed', handlePermissionChanged);
    const renderTitle = useCallback(() => {
        if (!hasValue(context.title))
            return null;
        return _jsx(HeaderItemWrapper, { children: _jsx("div", { className: "uxpcore_dashboardtitle__container", children: context.title }) });
    }, [context]);
    const logo = _jsx("div", { className: "uxpcore_header__logo", style: {
            backgroundImage: `url(${props.logo})`
        } });
    return _jsxs(_Fragment, { children: [expiresAt !== null && _jsx(PermissionChangedBanner, { expiresAt: expiresAt }), _jsxs("div", { className: "uxpcore_header__container", children: [_jsxs("div", { className: "uxpcore_header__left", children: [_jsx(SidebarToggleButton, { expandedSidebar: props.expandedSidebar, onClick: props.onToggleSidebar }), _jsx("div", { className: "uxpcore_header__logo_container", children: context.isPublicSession
                                    ? logo
                                    : _jsx(SafeLink, { to: "/view/system/home", className: "uxpcore_header__logo_link", children: logo }) })] }), _jsxs("div", { className: "uxpcore_header__middle", children: [renderTitle(), _jsx(HeaderNavigation, { navigationLinks: props === null || props === void 0 ? void 0 : props.navigationLinks })] }), _jsxs("div", { className: "uxpcore_header__right", children: [props === null || props === void 0 ? void 0 : props.renderRightSection, !context.isPublicSession && (_jsx(HeaderItemWrapper, { children: _jsx(NotificationCenter, {}) })), _jsx(HeaderItemWrapper, { children: _jsx(ThemeChanger, {}) }), !context.isPublicSession && (_jsx(HeaderItemWrapper, { children: _jsx(UserProfile, {}) }))] })] })] });
};
export const Header = memo(HeaderBase);
export const HeaderItemWrapper = (props) => {
    return _jsx("div", { className: "uxpcore_headeritem__container", children: props.children });
};
const SidebarToggleButton = (props) => {
    const context = useContext(UXPContext);
    const isRTL = (context === null || context === void 0 ? void 0 : context.direction) === 'rtl';
    // LTR: expanded = text-outdent, collapsed = text-indent
    // RTL: flip the logic (expanded = text-indent, collapsed = text-outdent)
    const iconName = isRTL
        ? (props.expandedSidebar ? 'text-indent' : 'text-outdent')
        : (props.expandedSidebar ? 'text-outdent' : 'text-indent');
    const ready = useIsPHIconReady(iconName);
    return _jsx("div", { className: classNames("uxpcore_sidebartogglebtn__container", {
            "uxpcore_sidebartogglebtn__container--expandedsidebar": props.expandedSidebar
        }), onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            props.onClick();
        }, children: _jsx("div", { className: "uxpcore_sidebartogglebtn__menuicon", children: ready
                ? _jsx(Icon, { icon: ['phl', iconName] })
                : _jsx(SkeletonLoader, { width: "100%", height: "100%", additionalStyle: {
                        borderRadius: '50%',
                        aspectRatio: '1'
                    } }) }) });
};
